import { buyGems } from "commerce/stores/buyGems";

import { dim }         from "stores/toggles";
import { activeQuote } from "stores/active-quote";
import { prompt }      from "stores/prompt";

export default function clickBuy({ featureDisabled, quote }, e) {
    if (featureDisabled) {
        return;
    }

    if (quote.tooExpensive) {
        return buyGems.set(true);
    }

    dim.set(true);
    activeQuote.setActiveQuote(quote);
    prompt.setPrompt("confirm");
}
